// extracted by mini-css-extract-plugin
module.exports = {"ldsRing":"Loader-module--ldsRing--3_Zt3","center":"Loader-module--center--3q0r2","rotate":"Loader-module--rotate--11_Jg","dash":"Loader-module--dash--3u-2J"};